import styled from 'styled-components';
import PortalIdParser from 'PortalIdParser';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import OnboardingTourButton from './OnboardingTourButton';
import { toShorthandSize } from 'foundations-components/transitional/utils/tShirtSizes';
import { BACK, FINISH, NEXT } from '../constants/TourActions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ButtonsWrapper = styled.div.withConfig({
  displayName: "OnboardingTourButtons__ButtonsWrapper",
  componentId: "sc-5gf1w6-0"
})(({
  theme
}) => {
  return {
    marginBottom: `-${theme.space['200']}`,
    // -8px
    marginRight: `-${theme.space['200']}` // -8px
  };
});
export default function OnboardingTourButtons({
  beforeBackClickHandler,
  buttons,
  buttonSize = 'md',
  completeActionKey,
  enableBackButton
}) {
  return /*#__PURE__*/_jsx(ButtonsWrapper, {
    children: /*#__PURE__*/_jsxs(TFlex, {
      justify: "between",
      wrap: "wrap",
      children: [enableBackButton && /*#__PURE__*/_jsx(OnboardingTourButton, {
        action: BACK,
        beforeBack: beforeBackClickHandler,
        marginBlockEnd: "200",
        marginInlineStart: "0",
        paddingInlineStart: "300"
        // TODO: fix this with better typing:
        // `toShorthandSize` returns `TShirtShortSizes` which has `lg` and `xl`,
        // but `ButtonSizesShorthand` does not support it
        ,
        size: toShorthandSize(buttonSize),
        use: "tertiary-light"
      }), buttons.map((button, index) => {
        const {
          action,
          beforeButtonEnabled,
          disableTaskCompletionModal,
          text,
          url,
          navigationCallbackPath
        } = button;
        const buttonProps = {
          marginInlineStart: '0',
          marginBlockEnd: '200',
          marginInlineEnd: '200',
          href: url && url.replace('%portalId%', String(PortalIdParser.get())),
          // TODO: fix this with better typing:
          // `toShorthandSize` returns `TShirtShortSizes` which has `lg` and `xl`,
          // but `ButtonSizesShorthand` does not support it
          size: toShorthandSize(buttonSize),
          use: !index ? 'primary' : undefined
        };
        if (action === NEXT) {
          return /*#__PURE__*/_jsx(OnboardingTourButton, Object.assign({
            action: NEXT,
            beforeButtonEnabled: beforeButtonEnabled,
            "data-test-id": `${NEXT}-onboarding-step-button`,
            navigationCallbackPath: navigationCallbackPath
          }, buttonProps, {
            children: text
          }), index);
        }
        if (action === FINISH) {
          const shouldOpenTaskCompletionModal = completeActionKey && !url && !disableTaskCompletionModal;
          return /*#__PURE__*/_jsx(OnboardingTourButton, Object.assign({
            action: FINISH,
            beforeButtonEnabled: beforeButtonEnabled,
            "data-test-id": `${FINISH}-onboarding-step-button`,
            taskKey: shouldOpenTaskCompletionModal ? completeActionKey : undefined
          }, buttonProps, {
            children: text
          }), index);
        }
        return /*#__PURE__*/_jsx(OnboardingTourButton, Object.assign({
          beforeButtonEnabled: beforeButtonEnabled,
          "data-test-id": "onboarding-step-button"
        }, buttonProps, {
          children: text
        }), index);
      })]
    })
  });
}